var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllusSaveSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 80,
    viewBox: "0 0 96 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "illus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.1408 0.00292969C68.2773 0.00292969 60.2815 8.00995 60.2815 17.8872C60.2815 27.7645 68.2773 35.7715 78.1408 35.7715C88.0042 35.7715 96 27.7645 96 17.8872C96 8.00995 88.0042 0.00292969 78.1408 0.00292969ZM78.1408 11.5556C81.6231 11.5556 84.4635 14.4 84.4635 17.8872C84.4635 21.3745 81.6231 24.2188 78.1408 24.2188C74.6584 24.2188 71.818 21.3745 71.818 17.8872C71.818 14.4 74.6584 11.5556 78.1408 11.5556Z",
    fill: "#0F1941"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 45.2432,
    y: 0.431396,
    width: 11.1864,
    height: 34.9114,
    fill: "#0F1941"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    x: 30.5354,
    y: 0.431396,
    width: 11.1864,
    height: 34.9114,
    fill: "#2175D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.59475 4.87334C6.19784 4.21096 6.66475 3.54858 7.24839 3.04205C10.7697 0.0418558 14.7968 -0.795861 19.1351 0.782164C23.4735 2.34071 26.0998 5.53572 26.8391 10.1139C27.52 14.2636 26.1777 17.7898 23.2011 20.7315C21.3529 22.5238 19.5437 24.3551 17.7344 26.1864C15.2248 28.6801 12.7151 31.1932 10.2055 33.6869C7.42348 36.4728 3.41585 36.4728 0.653301 33.6869C-3.66561 29.3619 -7.94561 24.998 -12.2645 20.6536C-14.7158 18.1794 -16.0192 15.2377 -15.9998 11.7504C-15.9803 6.15914 -11.6614 1.11335 -6.15579 0.236674C-2.05088 -0.425707 1.47039 0.7432 4.44694 3.64599C4.77766 3.99666 5.10839 4.36681 5.59475 4.87334Z",
    fill: "#E74536"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.85951 44.2266C-8.00394 44.2266 -15.9998 52.2336 -15.9998 62.1108C-15.9998 71.9881 -8.00394 79.9951 1.85951 79.9951C11.723 79.9951 19.7188 71.9881 19.7188 62.1108C19.7188 52.2336 11.723 44.2266 1.85951 44.2266ZM1.85951 55.7598C5.34187 55.7598 8.18224 58.6041 8.18224 62.0914C8.18224 65.5786 5.34187 68.4229 1.85951 68.4229C-1.62285 68.4229 -4.46321 65.5786 -4.46321 62.0914C-4.46321 58.6041 -1.62285 55.7598 1.85951 55.7598Z",
    fill: "#6BA5B4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.7563 49.097C60.3594 48.4346 60.8263 47.7722 61.4099 47.2657C64.9312 44.2655 68.9583 43.4278 73.2967 45.0058C77.635 46.5643 80.2614 49.7594 81.0007 54.3376C81.6816 58.4872 80.3392 62.0134 77.3432 64.9552C75.495 66.7475 73.6857 68.5788 71.8765 70.4101C69.3668 72.9037 66.8572 75.4169 64.3476 77.9105C61.5656 80.6964 57.5579 80.6964 54.7954 77.9105C50.4765 73.5856 46.1965 69.2217 41.8776 64.8772C39.4263 62.403 38.1228 59.4613 38.1423 55.974C38.1618 50.3828 42.4807 45.337 47.9863 44.4603C52.0912 43.7979 55.6125 44.9668 58.589 47.8696C58.9392 48.2008 59.2699 48.571 59.7563 49.097Z",
    fill: "#E74536"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    x: 23.7847,
    y: 44.4214,
    width: 11.3225,
    height: 35.3595,
    fill: "#2175D9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllusSaveSearch);
export default __webpack_public_path__ + "static/media/illusSaveSearch.5eeb75a4.svg";
export { ForwardRef as ReactComponent };